import { EmojiMartData } from '@emoji-mart/data'
import emojiDataRaw from '@emoji-mart/data/sets/15/all.json'

export const emojiData = emojiDataRaw as EmojiMartData

export const categoryIdToLegacyCategoryName: Record<string, string> = {
  people: 'smileys-&-people',
  nature: 'animals-&-nature',
  foods: 'food-&-drink',
  activity: 'activities',
  places: 'travel-&-places',
  objects: 'objects',
  symbols: 'symbols',
  flags: 'flags',
}
